import { memo, useCallback } from "react";

import { usePayjpCreditForm } from "./hooks";

import type { ChangeEventHandler } from "react";

type Props = {
	onSetTargetElement: (element: HTMLElement) => void;
	onChangeHasPayjpValidation: (hasError: boolean) => void;
	onChangeCardHolderName: (value: string) => void;
};

export const PayjpCreditForm = memo(
	({ onChangeHasPayjpValidation, onSetTargetElement, onChangeCardHolderName }: Props) => {
		const {
			errorMessage,
			cardHolderName,
			onChangeCardHolderName: _onChangeCardHolderName,
		} = usePayjpCreditForm(onSetTargetElement, onChangeHasPayjpValidation, onChangeCardHolderName);

		const handleChangeCardHolderName = useCallback<ChangeEventHandler<HTMLInputElement>>(
			(e) => {
				const { value } = e.target;

				_onChangeCardHolderName(value);
			},
			[_onChangeCardHolderName],
		);

		const showErrorMessage = Boolean(errorMessage);

		return (
			<div className="min-h-[112px]">
				<div className="mb-2 flex justify-start pl-1">
					<img
						className="mr-3 h-[18.75px] max-h-[18.75px] w-[30px] max-w-[30px]"
						src="https://editor-assets.chillnn.com/reservation/img/card/visa.png"
					/>
					<img
						className="mr-3 h-[18.75px] max-h-[18.75px] w-[30px] max-w-[30px]"
						src="https://editor-assets.chillnn.com/reservation/img/card/mastercard.png"
					/>
					<img
						className="mr-3 h-[18.75px] max-h-[18.75px] w-[30px] max-w-[30px]"
						src="https://editor-assets.chillnn.com/reservation/img/card/jcb.png"
					/>
					<img
						className="mr-3 h-[18.75px] max-h-[18.75px] w-[30px] max-w-[30px]"
						src="https://editor-assets.chillnn.com/reservation/img/card/americanExpress.png"
					/>
					<img
						className="h-[18.75px] max-h-[18.75px] w-[30px] max-w-[30px]"
						src="https://editor-assets.chillnn.com/reservation/img/card/discover.png"
					/>
				</div>

				<div className="rounded-md">
					<div className="relative flex flex-wrap">
						<div
							id="card-number"
							className="payjs-outer w-full rounded-t-md border border-bg-layer-200 px-3 py-2.5"
						>
							{/* ここにカード番号入力フォームが生成されます */}
						</div>
						<div
							id="card-expiry"
							className="payjs-outer box-border w-1/2  border-b border-l border-r border-bg-layer-200 px-3 py-2.5 text-sm"
						>
							{/* ここに有効期限入力フォームが生成されます */}
						</div>
						<div
							id="card-cvc"
							className="payjs-outer box-border w-1/2 border-b border-r border-bg-layer-200 px-3 py-2.5 text-sm"
						>
							{/* ここにCVC入力フォームが生成されます */}
						</div>
						<div className="w-full rounded-b-md border border-t-0 border-bg-layer-200 px-3 py-2.5">
							<input
								type="text"
								className="font-YuGothic text-sm outline-none placeholder:font-YuGothic placeholder:text-sm placeholder:font-thin"
								placeholder="カード名義"
								value={cardHolderName}
								onChange={handleChangeCardHolderName}
							/>
						</div>
					</div>

					{showErrorMessage && <p className="mt-2 text-sm text-error-600">{errorMessage}</p>}
				</div>
			</div>
		);
	},
);
